import { useContext, useEffect, useRef, useState } from 'react'
// import { ToDoListAdminProvider } from './ToDoListAdminProvider'
import { BsFillCaretDownFill, BsFillCaretUpFill } from 'react-icons/bs'
import { ToDoListAdminContext } from '../ToDoListAdmin'

export default function ToggleContainerComponent({ id, focused, open, header, className, children }) {
    const { focus, setFocus } = useContext(ToDoListAdminContext)
    const itemRef = useRef()
    const [isOpen, setIsOpen] = useState(open)
    useEffect(() => { setIsOpen(open) }, [open])

    // setFocus
    const _handleToggle = (e) => {
        e.stopPropagation()
        e.preventDefault()
        // console.log('..............||', focused, focus)
        if (!isOpen === true) setFocus(focused)
        setIsOpen(!isOpen)
    }

    return <div ref={itemRef} className={` ${className} `}>

        <button style={{ cursor: 'pointer' }} onClick={_handleToggle} className={`d-flex align-items-center toggle-bar ${className}`}>
            <div className='flex-shrink-1'>
                {isOpen ? <BsFillCaretUpFill className='m-2' /> : <BsFillCaretDownFill className='m-2' />}
            </div>
            <div className='flex-grow-1'>{header}</div>
        </button>
        <div className={isOpen ? '' : 'd-none'}>{children}</div>
    </div>
}
